(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["floating-cta"] && !Shopify.designMode) return;
  try {
    

const floatCTA = () => {
  const floatingCTA = document.getElementById("floating-cta");
  const firstSection = document.querySelector("main > *:first-child");
  const footer = document.querySelector("footer"); // Adjust selector as needed

  let pastFirstSection = false;
  let atFooter = false;

  const updateCTA = () => {
    if (pastFirstSection && !atFooter) {
      floatingCTA.classList.remove("hidden");
      floatingCTA.classList.add("show");
    } else {
      floatingCTA.classList.remove("show");
      floatingCTA.classList.add("hidden");
    }
  };

  if (firstSection) {
    const firstSectionObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        pastFirstSection = !entry.isIntersecting;
        updateCTA();
      });
    }, { threshold: 0 });
    firstSectionObserver.observe(firstSection);
  }

  if (footer) {
    const footerObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        atFooter = entry.isIntersecting;
        updateCTA();
      });
    }, { threshold: 0 });
    footerObserver.observe(footer);
  }
};

document.addEventListener("DOMContentLoaded", () => {
    floatCTA();
});

  } catch(e) { console.error(e); }
})();
})();
